<template>
  <div class="themes">
    <span style="margin-right: 15px">风格库</span>
    <div class="theme-box">
      <li
        :class="['style-item', { on: currentTagId == item.id }]"
        v-for="(item, index) in themes"
        :key="index + 'theme'"
        @click.stop="changeTheme(item)"
        @mouseenter="mounseEnterHandle(item, index)"
        @mouseleave="mounseLeaveHandle"
      >
        <span
          v-if="item.typeId === 1"
          class="color-btn"
          :style="{
            background: 'linear-gradient(135deg, ' + item.tagValue + ')',
            ...(enterBtnId === item.id ? enterStyle : {}),
          }"
        >
        </span>
        <span v-if="item.typeId === 6" class="style-btn">
          <img
            :src="require(`@/assets/images/styleImg/f-${item.id}.png`)"
            :alt="item.tagName"
          />
        </span>
        <el-tooltip
          v-show="isRefreshIcon && currentTagId === item.id"
          effect="dark"
          content="随机一个模板"
          placement="top"
        >
          <img
            class="refresh-icon"
            :style="{
              transform: `scale(.6) rotate(${-360 * rotateDeg}deg)`,
            }"
            src="@/assets/images/index/refresh.png"
          />
        </el-tooltip>
        <!-- <div class="popover" v-if="guidePopVisible && currentTagId === item.id">
          <span class="tip">点击所选「颜色」，随机生成模板~</span>
          <span class="btn" @click="guidePopVisible = false">知道了</span>
        </div> -->
      </li>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    currentTagId: {
      type: [Number, String],
      default: 0,
    },
    themes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // 鼠标移入风格btn时候的样式
      enterStyle: {},
      // 鼠标移入的风格btn
      enterBtnId: -1,
      // 是否显示刷新的图标
      isRefreshIcon: false,
      // 是否显示引导
      guidePopVisible: false,
      rotateDeg: 0,
    };
  },
  async mounted() {
    this.showGuideContorl();
  },
  methods: {
    // 鼠标移入样式
    mounseEnterHandle(styleData) {
      this.enterBtnId = styleData.id;
      this.enterStyle = {
        background: `linear-gradient(135deg, ${styleData.tagValue})`,
        "box-shadow": `0px 4px 7px 0px ${styleData.hoverColor}`,
      };
      this.isRefreshIcon =
        parseInt(this.currentTagId) === parseInt(styleData.id);
    },
    mounseLeaveHandle() {
      this.isRefreshIcon = false;
      this.enterBtnId = -1;
      this.enterStyle = {};
    },
    // 切换主题
    changeTheme(theme) {
      this.isRefreshIcon = true;
      // 如果鼠标点击的是当前的主题，那么就刷新素材
      if (theme.id === this.currentTagId) {
        this.$emit("updateMaterials");
        this.rotateDeg += 1;
      } else {
        this.$emit("regainMaterials", theme);
      }
    },
    // 初次进入页面显示引导
    showGuideContorl() {
      let fristEnter = localStorage["fristEnter"];
      if (!fristEnter) {
        this.guidePopVisible = true;
        localStorage["fristEnter"] = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin bg {
  margin-top: 20px;
  padding: 0 30px;
  border-radius: 6px;
  background: #f1f2f5;
  box-shadow: -1px -1px 1px 0px #eceef5 inset, 0px 1px 0px 0px #fff inset,
    0px 8px 10px 0px rgba(0, 0, 0, 0.06);
}
.themes {
  height: 60px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  @include bg;
  &:first-child {
    margin-right: 16px;
    font-size: 14px;
    color: #6d7278;
  }
  .theme-box {
    display: flex;
    justify-content: flex-start;
    font-size: 16px;
    color: #464c5e;
    .style-item {
      position: relative;
      margin: 0 10px;
      cursor: pointer;
      &:before {
        position: absolute;
        width: 18px;
        height: 18px;
        top: -3px;
        right: -6px;
        opacity: 0;
        background: url(../assets/images/index/select.png) no-repeat 0 0;
        content: "";
        background-size: 100% 100%;
        z-index: 10;
      }
      &.on {
        &:before {
          opacity: 1;
        }
      }
      .color-btn {
        position: relative;
        display: block;
        box-sizing: border-box;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        transition: all 0.2s;
      }
      .style-btn {
        position: relative;
        display: block;
        width: 76px;
        height: 32px;
        border-radius: 16px;
        transition: all 0.1s;
        cursor: pointer;
        img {
          display: block;
          width: 100%;
        }
        &:hover {
          box-shadow: 0 4px 7px rgba(#000, 0.2);
        }
      }
      .refresh-icon {
        position: absolute;
        left: 0;
        right: 0;
        width: 32px;
        top: 0;
        margin: 0 auto;
        transform: scale(0.6);
        image-rendering: -moz-crisp-edges;
        image-rendering: -o-crisp-edges;
        image-rendering: -webkit-optimize-contrast;
        image-rendering: crisp-edges;
        -ms-interpolation-mode: nearest-neighbor;
        transition: all cubic-bezier(0.63, 0.14, 0.38, 1.01) 0.5s;
      }
      // .the__choose--color-name {
      //   user-select: none;
      // }
      .popover {
        position: absolute;
        bottom: 52px;
        left: -128px;
        box-sizing: border-box;
        width: 290px;
        padding: 12px;
        background: #3f69f9;
        border-radius: 10px;
        z-index: 10;
        box-shadow: 2px 0px 4px 0px rgba(0, 0, 0, 0.15);
        .tip {
          display: inline-block;
          margin-right: 10px;
          color: #fff;
          font-size: 13px;
          z-index: 999;
        }
        .btn {
          display: inline-block;
          width: 50px;
          height: 24px;
          font-size: 13px;
          background: #ffffff;
          text-align: center;
          line-height: 24px;
          border-radius: 4px;
          color: #333;
        }
        &::after {
          content: "";
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          display: inline-block;
          border: 5px solid transparent;
          border-top-color: #3f69f9;
        }
      }
    }
  }
}
</style>
